module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_dress-975e43009b8af32499ef15e3e73c7da8.webp";